import(/* webpackMode: "eager" */ "/app/app/(dashboard)/overview/error.tsx");
